<template>
  <div class="container">
    <img class="emptyImg" src="../../../assets/emptyImg.png"/>
    <div v-if="pageName !== 'scholarships'">
      <h4 class="emptyMsg better_font">Looks like there is nothing to display. 
        Click below to start adding to your {{pageName}}!</h4>
      <button class="btn btn-primary better_font editBtnEmpty" @click="edit">Let's Get Started!</button>
    </div>
    <div v-else>
      <h4 class="emptyMsg better_font">You currently have no scholarship applications started.
      You will be able to view the status of your scholarship applications here.</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyMessage",
  props: {
    pageName: String,
  },
  data(){
    return{

    }
  },
  mounted(){
    
  },
  methods:{
    edit(){
      this.$emit('enterEdit');
    }
  }
}
</script>

<style scoped>

.emptyImg {
  width: 20%;
  margin-left: 40%;
  margin-right: 40%;
}

.emptyMsg {
  text-align: center;
  margin-top: 10px;
  color: #a6a6a6;
  max-width: 80%;
  margin-left: 10%;
  margin-right: 10%;
}

.editBtnEmpty {
  background-color: #a6a6a6;
  width: 50%;
  margin-left: 25%;
  margin-right: 25%;
}

.editBtnEmpty:hover {
  background-color: #666;
}

</style>
